"use strict";
/* globals module */
/**
 * @module shoppingCartPaymentClient
 * @description  Shopping Cart Payment Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Payment Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ShoppingCartPaymentClient = /** @class */ (function () {
    function ShoppingCartPaymentClient(shoppingCartPaymentRoute, apiClient) {
        this.shoppingCartPaymentRoute = shoppingCartPaymentRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ShoppingCartPaymentClient.prototype, "routeDefinition", {
        get: function () {
            return this.shoppingCartPaymentRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the calculateSummary action has been performed; this action calculateSummarys specified shopping cart item resources.
     * @method
     * @param data A collection of shopping cart item objects used to calculateSummary specified shopping cart item resources.
     * @returns A promise that is resolved once the calculateSummary action has been performed.
     * @example shoppingCartPaymentClient.calculateSummary(file)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    ShoppingCartPaymentClient.prototype.calculateSummary = function (data) {
        return this.apiClient.post(this.routeDefinition.calculateSummary(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the processCart action has been performed. This action will processCart shopping cart item resources from the system if successfully completed. Specified shopping cart items and all accompanying derived resources will be processCartd from the system.
     * @method
     * @param ids Collection of shopping cart item Id which uniquely identifies shopping cart item resources that need to be deleted.
     * @example // Remove original shopping cart item resources
                        shoppingCartPaymentClient.processCart(cartPaymentRequest)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ShoppingCartPaymentClient.prototype.processCart = function (data) {
        return this.apiClient.post(this.routeDefinition.processCart(data), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    ShoppingCartPaymentClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartPaymentRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartPaymentRoute !== "undefined" && _1.ShoppingCartPaymentRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ShoppingCartPaymentClient);
    return ShoppingCartPaymentClient;
}());
exports.ShoppingCartPaymentClient = ShoppingCartPaymentClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
